import React from 'react';
import styled from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

function Landscape() {
  return (
    <Component>
      <Slider />
      <Content>
        <Left>
          <Title />
          <Subtitle />
          <Tags>
            <Tag />
            <Tag />
            <Tag />
            <Tag />
          </Tags>
          <Badges>
            <Badge />
            <Badge />
          </Badges>
          <Link />
        </Left>
        <Right>
          <Price />
        </Right>
      </Content>
    </Component>
  );
}

export default Landscape;

const Component = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.gray500};
`;

const Slider = styled.div`
  position: relative;
  flex: 0 1 21.763%;
  border-radius: 8px 0 0 8px;
  ${placeholderAnimationCss}
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  padding: 25px 50px;
  flex: 0 1 calc(100% - 21.763%);
  background: ${(props) => props.theme.white_1};
`;

const Left = styled.div`
  flex: 1 1 calc(100% - 41.107%);
  max-width: calc(100% - 41.107%);
`;

const Title = styled.div`
  max-width: 60%;
  height: 35px;
  border-radius: 8px;
  ${placeholderAnimationCss}
`;

const Subtitle = styled.div`
  max-width: 20%;
  height: 21px;
  margin-top: 5px;
  border-radius: 8px;
  ${placeholderAnimationCss}
`;

const Tags = styled.div`
  display: flex;
  margin-top: 15px;
`;

const Tag = styled.div`
  flex: 0 0 14%;
  height: 36px;
  border-radius: 5px;
  margin-bottom: 5px;
  ${placeholderAnimationCss}

  &:not(:first-child) {
    margin-left: 5px;
  }
`;

const Badges = styled.div`
  display: flex;
  margin-top: 10px;
`;

const Badge = styled.div`
  flex: 0 0 25%;
  height: 32px;
  border-radius: 28px;
  margin-bottom: 5px;
  ${placeholderAnimationCss}

  &:not(:first-child) {
    margin-left: 5px;
  }
`;

const Link = styled.div`
  max-width: 100px;
  height: 23px;
  margin-top: 25px;
  border-radius: 8px;
  ${placeholderAnimationCss};
`;

const Right = styled.div`
  flex: 1 1 41.107%;
  max-width: 41.107%;
  margin-left: 50px;
`;

const Price = styled.div`
  max-width: 45%;
  height: 50px;
  border-radius: 2px;
  clip-path: polygon(
    0% 0%,
    calc(100% - 14px) 0%,
    100% 50%,
    calc(100% - 14px) 100%,
    0% 100%
  );
  ${placeholderAnimationCss};
`;
